import { useQuery } from "react-query";
import axios from "infra/http";

function useTotalDashboard(url: string) {
  return useQuery([url], async () => {
    const { data } = await axios.get<{
      total: number;
    }>(url);

    return data;
  });
}

export default useTotalDashboard;
